<template>
  <div class="side-menu">
    <div class="search-side">
      <div class="title-wrapper">
        <div class="font-topic-bold" v-tip>{{ app.name }}</div>
        <span v-if="isAppAdmin && !app.template" @click="clickApp()" class="icon-back">
          <svg-icon icon-class="back"></svg-icon>
        </span>
      </div>
      <div class="search-query">
        <el-input
          v-model="searchText"
          :class="themeStyle.search"
          prefix-icon="el-icon-search"
          placeholder="请输入"
          clearable
        ></el-input>
      </div>
      <div class="scroll-wrap" v-ps>
        <base-side-menu :menuList="filteredMenuList" :default-menu="defaultMenu"></base-side-menu>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSideMenu from "@/components/BaseComponents/SideMenu"
import { isAppAdmin } from "@/utils/checkPermission"
import { editableMenuList, uneditableMenuList } from "./static"
import { themeStyleMap } from "@/views/Front/Sheet/Layout/static"

export default {
  name: "side-menu",
  inject: ["app"],
  components: { BaseSideMenu },
  data() {
    return {
      themeStyleMap,
      editableMenuList,
      uneditableMenuList,
      searchText: "",
      debug: "false"
    }
  },
  computed: {
    isAppAdmin() {
      return isAppAdmin(this.app.id)
    },
    theme() {
      return this.$store.getters.theme
    },
    themeStyle() {
      return this.themeStyleMap[this.theme]
    },
    filteredMenuList() {
      let menuList =
        this.debug === "true"
          ? this.editableMenuList
          : this.app.editable
          ? this.editableMenuList
          : this.uneditableMenuList
      // let menuList = this.app.editable ? this.editableMenuList : this.uneditableMenuList
      if (!this.searchText) return menuList
      return menuList
        .map(menu => {
          return Object.assign({}, menu, {
            children: menu.children?.filter(subMenu => {
              return subMenu.label.includes(this.searchText)
            })
          })
        })
        .filter(menu => menu.label.includes(this.searchText) || !this._.isEmpty(menu.children))
    },
    defaultMenu() {
      if (!this.searchText) return []
      return this.filteredMenuList?.map(subMenuList => subMenuList.value)
    }
  },
  created() {
    if (this.$route.query.debug === "true") {
      this.debug = this.$route.query.debug
    }
  },
  methods: {
    clickApp() {
      this.$router.push({
        name: "worksheet",
        params: {
          appId: this.app.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  .search-side {
    padding: 50px 20px;
    .title-wrapper {
      display: flex;
      align-items: center;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 205px;
      .icon-back {
        font-size: 20px;
        margin-left: auto;
        cursor: pointer;
      }
    }
  }

  .search-query {
    position: absolute;
    padding-top: 10px;
    right: 20px;
    width: 205px;
  }
  .scroll-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
  }
  .search {
    ::v-deep {
      .el-input__inner {
        background-color: rgba(192, 196, 204, 0.3);
      }
    }
  }
}
</style>
